import React, { useRef } from 'react';
import { motion, useScroll, useTransform, MotionValue } from 'framer-motion';

interface ParallaxTextProps {
    children: React.ReactNode;
    offset?: number;
    className?: string;
    direction?: 'up' | 'down' | 'left' | 'right';
}

const ParallaxText: React.FC<ParallaxTextProps> = ({
                                                       children,
                                                       offset = 50,
                                                       className = '',
                                                       direction = 'up',
                                                   }) => {
    const ref = useRef<HTMLDivElement>(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ['start end', 'end start'],
    });

    const transformUp    = useTransform(scrollYProgress, [0, 1], [ offset, -offset]);
    const transformDown  = useTransform(scrollYProgress, [0, 1], [-offset,  offset]);
    const transformLeft  = useTransform(scrollYProgress, [0, 1], [ offset, -offset]);
    const transformRight = useTransform(scrollYProgress, [0, 1], [-offset,  offset]);

    const x: MotionValue<number> | number =
        direction === 'left'  ? transformLeft  :
            direction === 'right' ? transformRight :
                0;

    const y: MotionValue<number> | number =
        direction === 'up'    ? transformUp    :
            direction === 'down'  ? transformDown  :
                0;

    return (
        <div ref={ref} className={`overflow-hidden ${className}`}>
            <motion.div style={{ x, y }}>
                {children}
            </motion.div>
        </div>
    );
};

export default ParallaxText;